import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import TextThreadEditorVM from './textThread';
import './textThreadInlineFooter.html';
import './textThreadInlineFooter.scss';

interface TextThreadEditorInlineFooterVMConfig {
    editor: TextThreadEditorVM
}

@injectable()
export default class TextThreadEditorInlineFooterVM {
    labels = labels

    editor: TextThreadEditorVM

    imagesAreAllowed = ko.pureComputed(() => this.editor.imagesAreAllowed());
    videoIsAllowed = ko.pureComputed(() => this.editor.videoIsAllowed());
    audioIsAllowed = ko.pureComputed(() => this.editor.audioIsAllowed());
    
    allowToSave = ko.pureComputed(() => this.editor.allowToSave());
    allowToCancel = ko.pureComputed(() => this.editor.allowToCancel());

    constructor(
        @inject(wccModules.componentConfig) { editor }: TextThreadEditorInlineFooterVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.editor = editor;

        const { parentThread } = editor;

        const isReady = ko.pureComputed(() => editor.isReady());
        const isPrivate = ko.pureComputed(() => parentThread()?.visibleToId() != undefined);

        ko.applyBindingsToNode(info.element, {
            'visible': isReady,

            'css': {
                'thread-editor-text-inline-footer': true,
                'thread-editor-text-inline-footer--private': isPrivate
            }
        }, this);
    }

    save = () => this.editor.save()
    cancel = () => this.editor.cancel()

    pickImage = () => {
        this.editor.pickImage();
    }

    pickVideo = () => {
        this.editor.pickVideo();
    }

    pickAudio = () => {
        this.editor.pickAudio();
    }
}